import { render, staticRenderFns } from "./IndexPopper.vue?vue&type=template&id=02ab6fe8&scoped=true&"
import script from "./IndexPopper.vue?vue&type=script&lang=js&"
export * from "./IndexPopper.vue?vue&type=script&lang=js&"
import style0 from "./IndexPopper.vue?vue&type=style&index=0&id=02ab6fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab6fe8",
  null
  
)

export default component.exports